'use client';

import Link from 'next/link';

import MobileChatButton from '@/components/elements/Header/MobileChatButton';
import MobileMenu from '@/components/elements/Header/MobileMenu';
import { useAuth } from '@/hooks/useAuth';

function Header() {
  const { isLogin } = useAuth();

  return (
    <header className="relative z-50 flex h-16 w-full items-center bg-black px-4 py-2 md:hidden">
      <div className="flex w-full items-center justify-between">
        <Link href="/">
          <img src="/images/logo.svg" alt="" className="h-6 w-25.25 lg:h-8 lg:w-33.75" />
        </Link>
        <div className="flex items-center">
          {isLogin && <MobileChatButton />}
          <MobileMenu />
        </div>
      </div>
    </header>
  );
}

export default Header;
